import { Box, Flex } from '@chakra-ui/react';

import { Delete, Plus } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { InputV2 } from 'uiToolkitV1/InputV2';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

interface Setting {
  score: number;
  description: string;
  displayOrder: number;
}

const isEmptyString = (str: string = '') => str.trim() === '';

const isScoreNameValid = (scoreSetting: Setting[]) => {
  if (!scoreSetting) return false;
  return scoreSetting.every((setting) => {
    // each score should have a name
    if (isEmptyString(setting.description)) {
      return false;
    }
    return true;
  });
};

const ScoreSettings = ({ scoreSetting = [], onChange }: TextScoreSettingTableProps) => {
  const isValidScoreNames = isScoreNameValid(scoreSetting);

  // const handleScoreChange = (score, index: number) => {
  //   const newScoreSetting = scoreSetting.map((setting, i) => {
  //     if (i === index) {
  //       return { ...setting, score };
  //     }
  //     return setting;
  //   });
  //   onChange(newScoreSetting);
  // };

  const handleDescriptionChange = (description, index: number) => {
    const newScoreSetting = scoreSetting.map((setting, i) => {
      if (i === index) {
        return { ...setting, description };
      }
      return setting;
    });
    onChange(newScoreSetting);
  };

  const handleDelete = (index: number) => {
    const newScoreSetting = scoreSetting.filter((_, i) => i !== index);
    // recalculate the display order and score, both of them starting from 1
    const updatedScoreSetting = newScoreSetting.map((setting, i) => ({
      ...setting,
      displayOrder: i + 1,
      score: i + 1,
    }));
    onChange(updatedScoreSetting);
  };

  const handleAdd = () => {
    const lastScore = scoreSetting[scoreSetting.length - 1]?.score ?? 0;
    const lastDisplayOrder = scoreSetting[scoreSetting.length - 1]?.displayOrder ?? 0;
    const newScoreSetting = [
      ...scoreSetting,
      { score: lastScore + 1, description: '', displayOrder: lastDisplayOrder + 1 },
    ];
    onChange(newScoreSetting);
  };

  return (
    <>
      {!isValidScoreNames && (
        <TextLabel color="alerts.negative" m="12px 8px 0">
          Please make sure all scores have a name
        </TextLabel>
      )}

      {/* eslint-disable-next-line arrow-body-style */}
      {scoreSetting.map((setting, i) => {
        // const start = i - 1 >= 0 ? scoreSetting[i - 1].score : 0;

        return (
          <Flex key={setting.score} py="12px" alignItems="center">
            <Box
              cursor={scoreSetting.length > 1 ? 'pointer' : 'not-allowed'}
              tabIndex={0}
              onClick={() => {
                if (scoreSetting.length > 1) {
                  handleDelete(i);
                }
              }}
              style={{
                opacity: scoreSetting.length > 1 ? 1 : 0.5,
              }}
            >
              <Delete color="text.g2" boxSize="24px" />
            </Box>
            <Box width="86px">
              <TextBodyMedium ml="26px">{setting.score}</TextBodyMedium>
            </Box>
            <Box>
              <InputV2
                placeholder="Add score name"
                isDashed
                w="250px"
                onChange={(e) => handleDescriptionChange(e.target.value, i)}
                value={setting.description}
                maxLength={255}
                isInvalid={isEmptyString(setting.description) && !isValidScoreNames}
              />
            </Box>
          </Flex>
        );
      })}
      {/* eslint-disable-next-line react/no-unstable-nested-components */}
      <Button alignSelf="start" variant="tertiary" StartIcon={() => <Plus boxSize="24px" />} onClick={handleAdd}>
        Add outcome option
      </Button>
    </>
  );
};

interface TextScoreSettingTableProps {
  scoreSetting: Setting[];
  onChange?: (settings: Setting[]) => void;
}

const OutcomeSettingTable = ({ scoreSetting, onChange }: TextScoreSettingTableProps) => (
  <ScoreSettings scoreSetting={scoreSetting} onChange={onChange} />
);

export { OutcomeSettingTable };
